<template>
	<b-container>
		<b-row>
			<b-col>
				<b-form id="form" @submit="logIn">
					<b-form-row>
						<b-col>
							<b-img id="logo" :src="require('@/assets/logo.png')" rounded alt="LifeForce PT"></b-img>
						</b-col>
					</b-form-row>

					<b-form-row>
						<b-col>
							<h3>LifeForce PT & Wellness</h3>
						</b-col>
					</b-form-row>

					<b-form-row>
						<b-col>
							<h5>Medical Exercise Scheduler</h5>
						</b-col>
					</b-form-row>

					<b-form-row>
						<b-col>
							<b-form-group label="Email address" label-for="email" label-align="center">
								<b-form-input
									id="email"
									v-model="email"
									type="email"
									required
									placeholder="user@example.com"
								></b-form-input>
							</b-form-group>
						</b-col>
					</b-form-row>

					<b-form-row>
						<b-col>
							<b-form-group label="Password" label-for="password" label-align="center">
								<b-form-input
									id="password"
									v-model="password"
									type="password"
									required
									placeholder="password"
								></b-form-input>
							</b-form-group>
						</b-col>
					</b-form-row>

					<b-form-row fluid>
						<b-col>
							<b-link id="forgotPassword" v-b-modal="'forgotPasswordModal'">Forgot password?</b-link>
						</b-col>
					</b-form-row>

					<b-form-row fluid>
						<b-col>
							<b-button type="submit" variant="primary">Log In</b-button>
						</b-col>
					</b-form-row>
				</b-form>
			</b-col>
		</b-row>

		<b-modal
			id="forgotPasswordModal"
			title="Password reset"
			size="md"
			ok-title="Send password reset email"
			:ok-disabled="!this.resetEmail.length"
			@ok="passwordReset"
		>
			<b-container fluid>
				<b-row>
					<b-col>
						<strong class="my-1">Email</strong>
						<b-form-input v-model="resetEmail" placeholder="john.doe@example.com"></b-form-input>
					</b-col>
				</b-row>
			</b-container>
		</b-modal>
	</b-container>
</template>

<script>
const sha512 = require("js-sha512")

export default {
	name: "Login",
	data() {
		return {
			email: "",
			password: "",
			resetEmail: "",
		}
	},
	methods: {
		logIn: function(event) {
			event.preventDefault()
			let creds = {
				email: this.email,
				password: sha512(this.password),
			}

			this.$store
				.dispatch("login", creds)
				.then(() => this.$router.push("/"))
				.catch(res => {
					console.log(res)
					if (res.status === 400) {
						alert(
							"Incorrect credentials. Check your email/password and try again."
						)
					} else {
						alert("Server error. Try again.")
					}
				})
		},
		passwordReset: function() {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/resetPasswordEmail", {
					method: "POST",
					headers: new Headers({
						"Content-Type": "application/json",
					}),
					body: JSON.stringify({
						email: this.resetEmail,
					}),
				}).then(res => {
					if (res.ok) {
						alert(
							"Password reset email sent. Follow directions in the email to set your new password."
						)
						resolve()
					} else if (res.status === 400) {
						alert("Invalid email. Check email and try again.")
						reject()
					} else {
						alert("Error sending password reset email. Try again.")
						reject()
					}
				})
			})
		},
	},
}
</script>

<style scoped>
#form {
	display: block;
	border: 1px solid black;
	border-radius: 20px;
	margin: 25px auto;
	padding: 20px;
	text-align: center;
	max-width: 425px;
}

#logo {
	margin: 5px auto;
	width: 95%;
}

.form-group {
	margin: 15px auto;
}

input {
	text-align: center;
	width: 80%;
	margin: 0 auto;
}

strong {
	display: block;
	text-align: center;
}

#forgotPassword {
	display: block;
	text-align: right;
}

.form-row {
	margin: 10px auto;
}
</style>
